export default [
  {
    key: 'increasement',
    label: '#',
    thClass: 'w-50px',
  },
  {
    key: 'logo',
    label: 'field.logo',
  },
  {
    key: 'agentName',
    label: 'field.agent',
    stickyColumn: true,
    variant: 'light',
  },
  {
    key: 'bankName',
    label: 'field.bank',
  },
  {
    key: 'status',
    sortable: false,
    sortField: '',
    label: 'field.status',
  },
  {
    key: 'createdAt',
    sortable: true,
    sortField: 'createdAt',
    label: 'field.createDate',
  },
  {
    key: 'actions',
    label: 'general.action',
  },
]
